import { render, staticRenderFns } from "./GlobalMusicPlayer.vue?vue&type=template&id=22c22816&scoped=true"
import script from "./GlobalMusicPlayer.vue?vue&type=script&lang=js"
export * from "./GlobalMusicPlayer.vue?vue&type=script&lang=js"
import style0 from "./GlobalMusicPlayer.vue?vue&type=style&index=0&id=22c22816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c22816",
  null
  
)

export default component.exports